"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowLeft = void 0;
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
/**
 * Arrow indicator used for poppers.
 * Based on Paper to inherit the elevation color changes
 * this component get in the dark theme.
 */
exports.ArrowLeft = (0, material_1.styled)(Paper_1.default)(() => ({
    position: "absolute",
    width: "12px",
    height: "12px",
    clipPath: "polygon(100% 0%, 50% 50%, 100% 100%)",
    borderRadius: "0",
}));
